import { FC, Key } from "react";

import { Flex } from "antd";

import NewRecherche from "./NewRecherche";

const RechercheActions: FC<{
  selectedRowKeys: Key[];
  filters: Record<string, string[]>;
}> = ({ selectedRowKeys, filters }) => {
  return (
    <Flex gap={16}>
      <NewRecherche />
    </Flex>
  );
};

export default RechercheActions;
